import React from 'react'

function Footer() {
    return (
      <div className="flex flex-col bg-blue-850 text-white">
        <div className="flex flex-col lg:flex-row justify-between pb-24 pt-16 px-6 md:px-16  ">
          <div className="flex flex-col  ">
            <h1 className="text-sm">Company</h1>

            <a href="/about" className="pt-6 text-sm font-thin">
              About
            </a>
            <a href="/blog" className="py-6 text-sm font-thin">
              Blog
            </a>
          </div>

          <div className="flex flex-col ">
            <h1 className="text-sm">Our Work</h1>

            <a href="/projects" className="py-6 text-sm font-thin">
              Case Studies
            </a>
          </div>

          <div className="flex flex-col ">
            <h1 className="text-sm">Come join us</h1>

            <a href="/about/#career" className="py-6 text-sm font-thin">
              Career
            </a>
            {/* <p className="py-6">Terms of Service</p> */}
          </div>

          <div className="flex flex-col ">
            <h1 className="text-sm">Contact us</h1>
            <span className="pt-6 text-sm font-thin">
              47B Adekunle Fajuyi Way, Ikeja GRA, 100271 Ikeja.
            </span>
            <a
              href="mailto:mediaseal@mediaseal-ng.com"
              target="_blank"
              className="py-6 text-sm font-thin"
            >
              mediaseal@mediaseal-ng.com
            </a>

            <div className="flex flex-row">
              <a
                href="https://instagram.com/mediaseal"
                target="_blank"
                title="instagram"
                className="flex pr-3"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0009 7.4668C13.6834 7.4668 13.3925 7.47693 12.4823 7.51835C11.5739 7.55995 10.9538 7.70378 10.4112 7.9148C9.84993 8.13276 9.37384 8.42432 8.89952 8.89881C8.42485 9.37313 8.13329 9.84922 7.91462 10.4103C7.70307 10.9531 7.55906 11.5733 7.51818 12.4814C7.47746 13.3917 7.4668 13.6827 7.4668 16.0002C7.4668 18.3178 7.47711 18.6077 7.51835 19.5179C7.56013 20.4264 7.70395 21.0465 7.9148 21.5891C8.13294 22.1503 8.4245 22.6264 8.89899 23.1007C9.37313 23.5754 9.84922 23.8677 10.4101 24.0856C10.9531 24.2967 11.5733 24.4405 12.4816 24.4821C13.3918 24.5235 13.6825 24.5336 15.9999 24.5336C18.3176 24.5336 18.6075 24.5235 19.5178 24.4821C20.4262 24.4405 21.047 24.2967 21.59 24.0856C22.151 23.8677 22.6264 23.5754 23.1006 23.1007C23.5752 22.6264 23.8668 22.1503 24.0855 21.5893C24.2952 21.0465 24.4392 20.4262 24.4819 19.5181C24.5228 18.6079 24.5335 18.3178 24.5335 16.0002C24.5335 13.6827 24.5228 13.3918 24.4819 12.4816C24.4392 11.5732 24.2952 10.9531 24.0855 10.4105C23.8668 9.84922 23.5752 9.37313 23.1006 8.89881C22.6259 8.42414 22.1512 8.13258 21.5894 7.9148C21.0454 7.70378 20.425 7.55995 19.5165 7.51835C18.6063 7.47693 18.3165 7.4668 15.9983 7.4668H16.0009ZM15.2354 9.00457C15.4626 9.00421 15.7161 9.00457 16.0009 9.00457C18.2793 9.00457 18.5494 9.01274 19.4491 9.05363C20.2811 9.09168 20.7327 9.2307 21.0335 9.3475C21.4317 9.50217 21.7156 9.68706 22.0141 9.98573C22.3128 10.2844 22.4977 10.5688 22.6527 10.9671C22.7695 11.2675 22.9087 11.7191 22.9466 12.5511C22.9875 13.4507 22.9963 13.7209 22.9963 15.9982C22.9963 18.2756 22.9875 18.5458 22.9466 19.4454C22.9085 20.2774 22.7695 20.729 22.6527 21.0294C22.498 21.4276 22.3128 21.7112 22.0141 22.0097C21.7154 22.3084 21.4319 22.4932 21.0335 22.6479C20.733 22.7652 20.2811 22.9039 19.4491 22.942C18.5495 22.9828 18.2793 22.9917 16.0009 22.9917C13.7223 22.9917 13.4522 22.9828 12.5527 22.942C11.7207 22.9036 11.2691 22.7645 10.9681 22.6477C10.5699 22.4931 10.2855 22.3082 9.98679 22.0095C9.68812 21.7108 9.50323 21.4271 9.3482 21.0287C9.2314 20.7282 9.0922 20.2767 9.05433 19.4447C9.01344 18.5451 9.00527 18.2749 9.00527 15.9961C9.00527 13.7173 9.01344 13.4485 9.05433 12.549C9.09238 11.717 9.2314 11.2654 9.3482 10.9646C9.50287 10.5664 9.68812 10.2819 9.98679 9.98324C10.2855 9.68457 10.5699 9.49968 10.9681 9.34466C11.2689 9.22732 11.7207 9.08866 12.5527 9.05043C13.3399 9.01488 13.645 9.00421 15.2354 9.00243V9.00457ZM20.556 10.4215C19.9906 10.4215 19.532 10.8796 19.532 11.4451C19.532 12.0105 19.9906 12.4691 20.556 12.4691C21.1213 12.4691 21.58 12.0105 21.58 11.4451C21.58 10.8798 21.1213 10.4215 20.556 10.4215ZM16.0009 11.6179C13.5808 11.6179 11.6187 13.5801 11.6187 16.0002C11.6187 18.4203 13.5808 20.3816 16.0009 20.3816C18.4211 20.3816 20.3825 18.4203 20.3825 16.0002C20.3825 13.5801 18.4211 11.6179 16.0009 11.6179ZM16.0009 13.1557C17.5718 13.1557 18.8454 14.4292 18.8454 16.0002C18.8454 17.5711 17.5718 18.8447 16.0009 18.8447C14.4299 18.8447 13.1564 17.5711 13.1564 16.0002C13.1564 14.4292 14.4299 13.1557 16.0009 13.1557Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://business.google.com/dashboard/l/14184328472451046382"
                target="_blank"
                title="google business "
                className="flex pr-3"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="white"
                  />
                  <path
                    d="M25 13.525C25 14.6895 24.048 15.65 22.875 15.65C21.702 15.65 20.75 14.6895 20.75 13.525C20.75 14.6895 19.798 15.65 18.625 15.65C17.452 15.65 16.5 14.6895 16.5 13.525C16.5 14.6895 15.548 15.65 14.375 15.65C13.202 15.65 12.25 14.6895 12.25 13.525C12.25 14.6895 11.298 15.65 10.125 15.65C8.952 15.65 8 14.6895 8 13.525L9.1815 8.918C9.1815 8.918 9.428 8 10.295 8H22.705C23.572 8 23.8185 8.918 23.8185 8.918L25 13.525ZM24.15 16.67V23.3C24.15 24.235 23.385 25 22.45 25H10.55C9.615 25 8.85 24.235 8.85 23.3V16.67C9.40877 16.9007 10.0194 16.9767 10.6176 16.8899C11.2159 16.8032 11.7798 16.5569 12.25 16.177C12.8365 16.6445 13.576 16.925 14.375 16.925C15.1825 16.925 15.922 16.6445 16.5 16.177C17.0865 16.6445 17.826 16.925 18.625 16.925C19.4325 16.925 20.172 16.6445 20.75 16.177C21.328 16.6445 22.076 16.925 22.875 16.925C23.3255 16.925 23.759 16.8315 24.15 16.67ZM22.45 21.0305C22.45 20.8605 22.45 20.682 22.4075 20.495L22.382 20.359H19.8575V21.3535H21.396C21.345 21.5405 21.277 21.7275 21.1325 21.8805C20.852 22.161 20.4695 22.314 20.0615 22.314C19.6365 22.314 19.22 22.1355 18.914 21.838C18.3275 21.2345 18.3275 20.257 18.931 19.645C19.5175 19.05 20.4865 19.05 21.0985 19.6195L21.2175 19.73L21.9315 19.0075L21.7955 18.8885C21.3195 18.4465 20.6905 18.2 20.0275 18.2H20.019C19.3305 18.2 18.6845 18.4635 18.2 18.9395C17.6985 19.4325 17.418 20.0785 17.418 20.75C17.418 21.43 17.6815 22.059 18.166 22.5265C18.6709 23.0193 19.3475 23.2967 20.053 23.3H20.07C20.75 23.3 21.3535 23.0535 21.7955 22.62C22.195 22.212 22.45 21.6 22.45 21.0305Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://facebook.com/mediaseal"
                target="_blank"
                title="facebook"
                className="flex pr-3"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="white"
                  />
                  <path
                    d="M17.418 23V16.6243H19.888L20.2551 14.128H17.418V12.538C17.418 11.8177 17.6484 11.3245 18.8357 11.3245H20.34V9.09892C19.6081 9.03062 18.8723 8.99764 18.1362 9.00013C15.9529 9.00013 14.4539 10.1608 14.4539 12.2914V14.1234H12V16.6197H14.4593V23H17.418Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/mediaseal-wpi"
                target="_blank"
                title="linkedin"
                className="flex "
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8.42027C7 8.04359 7.14964 7.68234 7.41599 7.41599C7.68234 7.14964 8.04359 7 8.42027 7H22.5782C22.7649 6.9997 22.9497 7.03621 23.1223 7.10746C23.2948 7.17871 23.4516 7.28329 23.5837 7.41522C23.7158 7.54714 23.8205 7.70382 23.8919 7.87628C23.9634 8.04874 24.0001 8.2336 24 8.42027V22.5782C24.0002 22.7649 23.9636 22.9498 23.8923 23.1224C23.8209 23.2949 23.7163 23.4517 23.5843 23.5837C23.4523 23.7158 23.2956 23.8205 23.1231 23.892C22.9506 23.9634 22.7657 24.0001 22.579 24H8.42027C8.23369 24 8.04895 23.9632 7.87658 23.8918C7.70421 23.8204 7.54761 23.7157 7.41572 23.5837C7.28382 23.4518 7.17922 23.2951 7.10789 23.1227C7.03656 22.9503 6.9999 22.7655 7 22.579V8.42027ZM13.7289 13.4816H16.0309V14.6376C16.3631 13.9731 17.2131 13.375 18.4905 13.375C20.9392 13.375 21.5195 14.6987 21.5195 17.1274V21.6262H19.0414V17.6806C19.0414 16.2975 18.7091 15.517 17.8653 15.517C16.6946 15.517 16.2078 16.3585 16.2078 17.6806V21.6262H13.7289V13.4816ZM9.47891 21.5203H11.9578V13.375H9.47891V21.5195V21.5203ZM12.3125 10.7184C12.3172 10.9306 12.2794 11.1417 12.2014 11.3391C12.1234 11.5366 12.0068 11.7164 11.8583 11.8682C11.7099 12.02 11.5326 12.1405 11.3369 12.2229C11.1412 12.3052 10.931 12.3476 10.7188 12.3476C10.5065 12.3476 10.2963 12.3052 10.1006 12.2229C9.90491 12.1405 9.72764 12.02 9.57918 11.8682C9.43073 11.7164 9.31408 11.5366 9.23609 11.3391C9.15809 11.1417 9.12033 10.9306 9.125 10.7184C9.13417 10.3018 9.30612 9.90529 9.604 9.6139C9.90189 9.3225 10.302 9.15932 10.7188 9.15932C11.1355 9.15932 11.5356 9.3225 11.8335 9.6139C12.1314 9.90529 12.3033 10.3018 12.3125 10.7184Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <hr className="opacity-10" />
        <div className="flex flex-row justify-center lg:justify-between items-center py-5 px-16 ">
          <p className="text-xs font-thin">
            © {new Date().getFullYear()} Mediaseal. All rights reserved
          </p>
        </div>
      </div>
    )
}

export default Footer
